import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { fundraisingService } from '../../services/fundraisingService';

export const useGetLenderFundraisingStatusByCompanyId = companyId => {
  return useQuery({
    enabled: !!companyId,
    queryKey: [QUERY_KEYS.fundraising.lender_fr_status_by_company_id, companyId],
    queryFn: () =>
      fundraisingService.lenderFundraisingStatus(companyId).then(response => {
        const { status, data } = response;
        if (status === 200) {
          return data;
        }
        throw new Error('Error fetching founder application');
      }),
  });
};
